import { inject, Injectable, DOCUMENT } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard {}

export interface RedirectGuardData {
  externalUrl: string;
}

export const redirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const document: Document = inject(DOCUMENT);
  const data: RedirectGuardData = route.data as RedirectGuardData;

  document.location.assign(data.externalUrl);
  return false;
};
